import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

// 获取指标下拉
export const getTargetList = (params) =>
  apiBaseUrl.get('spmodel/mgr/indicators/select', params);
// 获取指标下拉
export const getLabelCompList = (params) =>
  apiBaseUrl.get('spmodel/mgr/label/select/component', params);

// 新增单个规则
export const ruleCreate = (params) =>
  apiBaseUrl.post('spmodel/mgr/rule/create', params);

// 查询单个规则
export const getRule = (params) =>
  apiBaseUrl.get(`spmodel/mgr/rule/${params.id}`, params.params);

// 删除单个规则
export const delCreate = (params) =>
  apiBaseUrl.post(`spmodel/mgr/rule/delete/${params.id}`, params.params);

// 更新单个规则
export const ruleEdit = (params) =>
  apiBaseUrl.post(`spmodel/mgr/rule/update/${params.id}`, params.params);

// 元数据表选择列表
export const metacolumnSelect = (params) =>
  apiBaseUrl.post('spmodel/mgr/meta/table/column/select', params);
// 获取指标下拉

export const getLabelList = params =>
  apiBaseUrl.post('spmodel/mgr/label/select', params);
